import React, { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Styles from './InlineDatePicker.module.less';
import moment from 'moment';
import { voidFunc } from '../../constants/PropTypeUtils';
import { useLangFile } from '../../context/LanguageContext';
import clsx from 'clsx';
import { DatePicker } from '@mui/x-date-pickers';
import { Event } from '@mui/icons-material';

const InlineDatePicker = (props: InlineDatePicker.propTypes) => {
  const LangFile = useLangFile();
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [date, setDate] = useState(props.value);

  useEffect(() => {
    setDate(props.value);
  }, [props.value]);

  const handleOpen = useCallback(() => {
    if (!props.disabled) setCalendarOpen(true);
  }, [props.disabled]);

  const handleClose = useCallback(() => setCalendarOpen(false), []);

  const handleOnChange = useCallback(
    (value) => {
      const d = value ? moment(value) : null;
      setDate(d);
      props.onChange(d);
    },
    [props.onChange]
  );

  return (
    <Box>
      <DatePicker
        format={props.format}
        open={calendarOpen}
        onOpen={handleOpen}
        onClose={handleClose}
        slots={{ openPickerIcon: Event }}
        slotProps={{
          textField: {
            className: Styles.DatePicker,
            error: props.error,
            variant: 'standard',
            placeholder: LangFile.InlineDatePicker.selectDate,
            InputProps: { classes: { root: clsx({ [Styles.InputError]: props.error }) } },
            onClick: handleOpen,
          },
          openPickerButton: { size: 'small' },
        }}
        label={props.label}
        disabled={props.disabled}
        value={date ? moment(date) : null}
        onChange={handleOnChange}
      />
    </Box>
  );
};

InlineDatePicker.propTypes = {
  value: PropTypes.any,
  label: PropTypes.any,
  format: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
};

InlineDatePicker.defaultProps = {
  label: PropTypes.any,
  format: 'DD/MM/YYYY',
  onChange: voidFunc,
};

export default memo(InlineDatePicker);
